import { useQuery } from 'react-query';
import { getDataPromise } from 'brock-fetch-utils';
import getUri from './getUri';

export function fetchFlightList(airlineCode, selectedStation, outboundTerminal) {
    return () =>
        getDataPromise(
            getUri(
                `FlightList?airlineCode=${airlineCode}&selectedStation=${selectedStation}&outboundTerminal=${outboundTerminal}`
            )
        );
}

export function fetchBagLocations(flightId) {
    return () => getDataPromise(getUri(`BagLocation/GetBagsAtLocations?flightId=${flightId}`));
}

export function fetchConfiguredLocations() {
    return () => getDataPromise(getUri(`BagLocation/GetConfiguredLocations`));
}

export function getFlightListQueryKey(airlineCode, selectedStation, outboundTerminal) {
    return ['flightList', airlineCode, selectedStation, outboundTerminal];
}

export function buildFlightListQuery(airlineCode, selectedStation, outboundTerminal) {
    return {
        queryKey: getFlightListQueryKey(airlineCode, selectedStation, outboundTerminal),
        queryFn: fetchFlightList(airlineCode, selectedStation, outboundTerminal),
        enabled: true,
        refetchInterval: 60000,
        staleTime: 60000,
    };
}

export function getBagLocationsQueryKey(flightId) {
    return ['bagLocations', flightId];
}

export function getConfiguredLocationsQueryKey() {
    return ['bagLocations'];
}

export function buildBagLocationsQuery(flightId) {
    return {
        queryKey: getBagLocationsQueryKey(flightId),
        queryFn: fetchBagLocations(flightId),
        enabled: !!flightId,
        refetchInterval: 60000,
        staleTime: 60000,
    };
}

export function buildConfiguredLocationsQuery() {
    return {
        queryKey: getConfiguredLocationsQueryKey(),
        queryFn: fetchConfiguredLocations(),
        enabled: true,
        refetchInterval: 60000,
        staleTime: 60000,
    };
}

export function getConfiguredSystemManifestQueryKey() {
    return ['bagDetailLink'];
}

export function fetchSystemManifest() {
    return () => getDataPromise(getUri(`SystemManifestApi/GetSystemManifest`));
}

export function buildSystemManifestQuery() {
    return {
        queryKey: getConfiguredSystemManifestQueryKey(),
        queryFn: fetchSystemManifest(),
        enabled: true,
        refetchInterval: 60000,
        staleTime: 60000,
    };
}

export function getHelpPageUrl() {
    const { data: helpPageUrl, ...payload } = useQuery({
        queryKey: ['helpPageUrl'],
        queryFn: () => getDataPromise(getUri(`HelpPage/GetHelpPageUrl`)),
        staleTime: 60000,
    });
    return { helpPageUrl, ...payload };
}
